// extracted by mini-css-extract-plugin
export var button = "SignUpForm-module__button___M01Ve";
export var container = "SignUpForm-module__container___ocpvJ";
export var content = "SignUpForm-module__content___U8HTr";
export var create = "SignUpForm-module__create____xRcw";
export var form = "SignUpForm-module__form___wdXD3";
export var header = "SignUpForm-module__header___YBkBn";
export var or = "SignUpForm-module__or___Kpug3";
export var tagalongHeading = "SignUpForm-module__tagalongHeading___KizqZ";